import { FC } from "react";
import { Text } from "@smile2impress/components/relaunch";

export type FooterCopyrightProps = {
    text: string;
};

export const FooterCopyright: FC<FooterCopyrightProps> = ({ text }) => (
    <Text textStyle="body" opacity="0.5">
        {text}
    </Text>
);
